import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To migrate your events, we'll be using the `}<a parentName="p" {...{
        "href": "/docs/apps/replicator"
      }}>{`PostHog Replicator app`}</a>{`:`}</p>
    <ol>
      <li parentName="ol">{`Disable the GeoIP plugin of your new PostHog instance`}</li>
      <li parentName="ol">{`Log in to your old PostHog instance`}</li>
      <li parentName="ol">{`Click 'Apps' on the left-hand tool bar`}</li>
      <li parentName="ol">{`Search for 'Replicator'`}</li>
      <li parentName="ol">{`If self-hosted, select the app, press 'Install' (or make sure it's the latest version)`}</li>
      <li parentName="ol">{`For the configuration details using the following:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`Host`}</inlineCode>{`: the hostname of your new PostHog instance e.g. `}<inlineCode parentName="li">{`app.posthog.com`}</inlineCode>{` if you are using US cloud, `}<inlineCode parentName="li">{`eu.posthog.com`}</inlineCode>{` if you were are EU cloud, or the domain you'll be sending events to if you are self-hosting`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`Project API Key`}</inlineCode>{`: the API key for the new project that you want to send events to - found in the project settings page.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`After clicking save and activating it (toggle on the left side), the Replicator will start to run. Any events added to your old instance will be replicated in your new instance. It can take a little while (15-20 minutes) for the first events to show up.`}</li>
      <li parentName="ol">{`Once the Replicator is activated, go back to the configuration menu and click the gear next to "Export historical events" under "Jobs." On the calendar, select a start and end date, then click "Run job now." This will begin the process of historical events being import (and might take a while). You can see the progress in logs or by clicking the "App metrics" button (graph) and going to the "Historical exports" tab.`}</li>
      <li parentName="ol">{`To track progress of the export you can click the graph icon next to the Replicator app and then click on the "Historical Exports" tab`}</li>
      <li parentName="ol">{`Re-enable the GeoIP plugin of your new PostHog instance`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      